// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"back-button_buttonWrapper__E6imH","button":"back-button_button__PxULV","buttonLabel":"back-button_buttonLabel__GWHDA"};